"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimFileType = void 0;
var ClaimFileType;
(function (ClaimFileType) {
    ClaimFileType["AdobeReaderFile"] = "pdf";
    ClaimFileType["ExcelFile"] = "xls";
    ClaimFileType["OfficeExcelMacroFile"] = "xlsm";
    ClaimFileType["OfficeExcelFile"] = "xlsx";
    ClaimFileType["JpegFile"] = "jpg";
    ClaimFileType["PngFile"] = "png";
    ClaimFileType["OfficeDocumentFile"] = "docx";
    ClaimFileType["BitMapFile"] = "bitmap";
    ClaimFileType["TextFile"] = "txt";
    ClaimFileType["CommaSeperatedFile"] = "csv";
})(ClaimFileType = exports.ClaimFileType || (exports.ClaimFileType = {}));
